import { produce } from 'immer';

import { SnapdocsClosingLoadState } from 'constants/snapdocsClosing';

import { SNAPDOCS_CLOSING_ACTION_TYPE } from '../actions';

const initialState = {
  applicationId: null,
  requestId: null,
  loadState: SnapdocsClosingLoadState.LOADING,
  errorMessage: null,
  status: null,
  blocks: {},
  blockErrors: {},
};

const snapdocsClosingReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case SNAPDOCS_CLOSING_ACTION_TYPE.GET_SNAPDOCS_CLOSING_REQUEST:
        return {
          ...initialState,
          applicationId: payload.applicationId,
          requestId: payload.requestId,
        };

      case SNAPDOCS_CLOSING_ACTION_TYPE.GET_SNAPDOCS_CLOSING_SUCCESS:
        if (payload.requestId !== state.requestId) {
          return state;
        }

        draft.loadState = SnapdocsClosingLoadState.LOADED;
        draft.status = payload.status;
        draft.blocks = payload.blocks;
        draft.blockErrors = payload.blockErrors;
        break;

      case SNAPDOCS_CLOSING_ACTION_TYPE.GET_SNAPDOCS_CLOSING_FAILURE:
        if (payload.requestId !== state.requestId) {
          return state;
        }

        draft.loadState = payload.loadState;
        draft.errorMessage = payload.errorMessage;
        break;

      default:
        return state;
    }
  });

export default snapdocsClosingReducer;
